import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { PreHeadline } from './components/PreHeadline';
import { HeroSection } from './components/HeroSection';
import { StoryHook } from './components/StoryHook';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { SymptomsSection } from './components/SymptomsSection';
import { ProductPresentation } from './components/ProductPresentation';
import { BundleStack } from './components/BundleStack';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { UrgencySection } from './components/UrgencySection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Disclaimer } from './components/Disclaimer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-warmWhite font-sans selection:bg-accent/30" data-id="element-0">
      <PreHeadline data-id="element-1" />
      <HeroSection data-id="element-2" />
      <StoryHook data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <SymptomsSection data-id="element-6" />
      <ProductPresentation data-id="element-7" />
      <BundleStack data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Disclaimer data-id="element-14" />
      <StickyCTA data-id="element-15" />
    </div>;
}